import NewspaperIcon from '@mui/icons-material/Newspaper';
import StarIcon from '@mui/icons-material/Star';
import VerifiedIcon from '@mui/icons-material/Verified';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Card, Skeleton, Stack, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import CardWithIcon from '../../components/CardWithIcon/CardWithIcon';

export const MetricsCards = ({
  metrics,
  loading,
  title,
  progressBar = false,
}) => {
  const t = useTranslate();
  return (
    <Card
      elevation={0}
      sx={{
        background: '#fff',
        color: '#000',
        padding: '24px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      {title && (
        <Typography
          fontSize={26}
          fontWeight="600"
          sx={{ marginBottom: '26px' }}
        >
          {t('resources.dashboard.welcome.goal_month')}
        </Typography>
      )}
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={{ xs: 2, md: 4, lg: 6 }}
        gap={2}
      >
        {loading ? (
          <>
            <Skeleton variant="rounded" width={'100%'} height={80} />
            <Skeleton variant="rounded" width={'100%'} height={80} />
            <Skeleton variant="rounded" width={'100%'} height={80} />
            <Skeleton variant="rounded" width={'100%'} height={80} />
          </>
        ) : (
          <>
            <CardWithIcon
              to="/commands"
              icon={NewspaperIcon}
              title={'Vistas'}
              percentage={
                metrics.visits
                  ? ((metrics.visits * 100) / metrics.target_visits).toFixed(2)
                  : 0
              }
              value={metrics.visits ?? 0}
              target={metrics.target_visits ?? undefined}
              color={'visits'}
              progressBar={progressBar}
            />
            <CardWithIcon
              to="/commands"
              icon={VisibilityIcon}
              title={'Notas'}
              percentage={
                metrics.notes
                  ? ((100 * metrics.notes) / metrics.target_notes).toFixed(2)
                  : 0
              }
              value={metrics.notes ?? 0}
              target={metrics.target_notes ?? undefined}
              color={'notes'}
              progressBar={progressBar}
            />
            <CardWithIcon
              to="/commands"
              icon={VerifiedIcon}
              title={'Calidad'}
              percentage={
                metrics.rfv
                  ? ((metrics.rfv * 100) / metrics.target_rfv).toFixed(2)
                  : 0
              }
              value={metrics.rfv ?? 0}
              target={metrics.target_rfv ?? undefined}
              color={'rfv'}
              progressBar={progressBar}
            />
            <CardWithIcon
              to="/commands"
              icon={StarIcon}
              title={'Suscriptores'}
              percentage={
                metrics.subscribers
                  ? (
                      (metrics.subscribers * 100) /
                      metrics.target_subscribers
                    ).toFixed(2)
                  : 0
              }
              value={metrics.subscribers ?? 0}
              target={metrics.target_subscribers ?? undefined}
              color={'subscribers'}
              progressBar={progressBar}
            />
          </>
        )}
      </Stack>
    </Card>
  );
};
